import React, {useEffect, useState} from 'react';
import './styles.scss';
import {Column, Row} from '../../../../components/layout';
import {colors} from '../../../../util/colors';
import * as fonts from '../../../../util/fonts';
import StepImage from '../../../../components/stepper/stepper-header/step-image';
import {strings} from '../../../../util/strings';
import {addToWizard, setWizard} from '../../../../store/actions';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {Icons} from '../../../../util/icons';
import Icon from '../../../../components/icon';
import Header2 from '../../../../components/headers/header2';
import {getCurrencyCode} from '../../../../util/utility';

interface ReimbursementSuccessProps {
  user?: any;
  valid?: boolean;
  wizard: any;
  setWizard(value: any): void;
  ReimbursementDate?: any;
  labels: typeof strings.pt.createRefund;
  refundLabels: typeof strings.pt.refund;
  globalStyles: any;
}

function ReimbursementSuccess({
  labels,
  wizard,
  refundLabels,
  setWizard,
  globalStyles,
}: ReimbursementSuccessProps) {
  const history = useHistory();

  if (!!!history.location.state) {
    history.push('/historico-reembolsos');
  }
  const [selectedItem, setSelectedItem] = useState<any>(history.location.state);
  const [expensesFinal, setExpensesFinal] = useState<any[]>([]);
  const process = '--';
  const selectedPatient = selectedItem?.patientName || selectedItem?.patient;
  const occorenceDate = selectedItem.dateTime;
  const currentTime = selectedItem.currentTime
    ?.split(':')
    ?.map((e: any) => (+e < 10 ? '0' + e : e))
    .join(':');

  useEffect(() => {
    const newExpensesFinal: any[] = [];
    selectedItem.procedures.map((procedure: any) => {
      selectedItem.expenses.map((expense: any) => {
        if (
          procedure.catCode == expense.coverage &&
          procedure.procCode == expense.medicalAct
        ) {
          newExpensesFinal.push({
            cover: procedure.catCodeDesc,
            actoMedico: procedure.procCodeDesc,
            amountclaimed: expense.value,
            coverage: expense.coverage,
            medicalAct: expense.medicalAct,
            catName: procedure.catCodeDesc,
          });
        }
      });
    });
    setExpensesFinal(newExpensesFinal);
  }, []);

  function calculateTotalValue(value: number) {
    const roundedvalue = Math.round((value + Number.EPSILON) * 100) / 100;
    return roundedvalue;
  }

  let totalValue = 0;
  return (
    <>
      <Column>
        <Row className="reimbursement-header-row">
          <Header2
            className="reimbursement-header"
            style={{
              ...fonts.XL,
              color: colors.black,
              fontWeight: 'bold',
            }}>
            {labels?.createRefund_refundRequest}
          </Header2>
        </Row>
        <Row className="reimbursement-subtitle-row">
          <p>{labels?.createRefund_hoursToPayment}</p>
        </Row>
      </Column>
      <Column className="reimbursement-success-container">
        <Row className="reimbursement-success-icon-row">
          <StepImage step="✓" stepFill={colors.green} />
        </Row>
        <p className="reimbursement-success-title" style={{...fonts.ML}}>
          {labels?.createRefund_sent}
        </p>
        <p
          className="reimbursement-success-time"
          style={{...fonts.ML, fontWeight: 'bold'}}>
          {currentTime}
        </p>
        <Column className="reimbursement-success-content-container">
          <Column className="reimbursement-success-outer">
            <Column className="reimbursement-success-box-column">
              <Row className="reimbursement-success-row">
                <Column className="reimbursement-success-row-column column-responsive">
                  <Row
                    className="reimbursement-success-row-template success-responsive"
                    style={{flexWrap: 'wrap'}}>
                    <Column className="reimbursement-success-row-left left-success">
                      <Row className="reimbursement-success-row-left-align">
                        <Column style={{...fonts.ML, textAlign: 'left'}}>
                          {refundLabels.refundDetail_process}
                        </Column>
                        <Column
                          className="reimbursement-success-result"
                          style={{...fonts.ML}}>
                          {process}
                        </Column>
                      </Row>
                      <Row className="reimbursement-success-row-left-align">
                        <Column style={{...fonts.ML, textAlign: 'left'}}>
                          {refundLabels.refundDetail_pacient}
                        </Column>
                        <Column
                          className="reimbursement-success-result"
                          style={{...fonts.ML}}>
                          {selectedPatient}
                        </Column>
                      </Row>
                    </Column>
                    <Column className="reimbursement-success-row-right right-success">
                      <Row className="reimbursement-success-row-left-align">
                        <Column style={{...fonts.ML, textAlign: 'left'}}>
                          {refundLabels.refundDetail_date}
                        </Column>
                        <Column
                          className="reimbursement-success-result"
                          style={{...fonts.ML}}>
                          {occorenceDate}
                        </Column>
                      </Row>
                    </Column>
                  </Row>
                </Column>
              </Row>
            </Column>
          </Column>
        </Column>
        {expensesFinal.map((expense) => {
          const value = Number(expense.amountclaimed);
          totalValue += value;
          return (
            <div>
              <Column className="reimbursement-success-outer">
                <Column className="reimbursement-success-box-column">
                  <Row className="reimbursement-success-row">
                    <Column className="reimbursement-success-row-column column-responsive">
                      <Row
                        className="reimbursement-success-row-template success-responsive"
                        style={{flexWrap: 'wrap'}}>
                        <Column className="reimbursement-success-row-left left-success">
                          <Row className="reimbursement-success-row-left-align">
                            <Column style={{...fonts.ML, textAlign: 'left'}}>
                              {refundLabels.refundDetail_coverage}
                            </Column>
                            <Column
                              className="reimbursement-success-result"
                              style={{...fonts.ML}}>
                              {expense.catName}
                            </Column>
                          </Row>
                          <Row className="reimbursement-success-row-left-align">
                            <Column style={{...fonts.ML, textAlign: 'left'}}>
                              {refundLabels.refundDetail_medicalAct}
                            </Column>
                            <Column
                              className="reimbursement-success-result"
                              style={{...fonts.ML}}>
                              {expense.actoMedico}
                            </Column>
                          </Row>
                        </Column>
                        <Column className="reimbursement-success-row-right right-success">
                          <Row className="reimbursement-success-row-left-align">
                            <Column
                              className="reimbursement-success-right-label"
                              style={{...fonts.ML, textAlign: 'left'}}>
                              {refundLabels.refundDetail_value}
                            </Column>
                            <Column
                              className="reimbursement-success-result"
                              style={{...fonts.ML}}>
                              {expense.amountclaimed}{' '}
                              {getCurrencyCode(undefined, 'createRefund')}
                            </Column>
                          </Row>
                        </Column>
                      </Row>
                    </Column>
                  </Row>
                </Column>
              </Column>
              <Column className="reimbursement-success-extra-info-outer">
                <Column className="reimbursement-success-extra-info-column">
                  <Row className="reimbursement-success-row">
                    <Column className="reimbursement-success-row-column column-responsive">
                      <Row className="reimbursement-success-row-template success-responsive">
                        <Column className="reimbursement-success-row-left left-success reimbursement-success-total-amount-left-container"></Column>
                        <Column className="reimbursement-success-row-right right-success">
                          <Row className="reimbursement-success-row-left-align">
                            <Column
                              className="reimbursement-success-right-label"
                              style={{
                                ...fonts.ML,
                                fontWeight: 'bold',
                                opacity: 0.5,
                              }}>
                              {refundLabels.refundDetail_client}
                            </Column>
                            <Column
                              className="reimbursement-success-result"
                              style={{
                                ...fonts.ML,
                                opacity: 0.5,
                              }}>
                              {'-'} {getCurrencyCode(undefined, 'createRefund')}
                            </Column>
                          </Row>

                          <Row className="reimbursement-success-row-left-align reimbursement-detail-last-label">
                            <Column
                              className="reimbursement-success-right-label reimbursement-success-row-detail-label"
                              style={{
                                ...fonts.ML,
                                fontWeight: 'bold',
                                opacity: 0.5,
                              }}>
                              {refundLabels.refundDetail_refundValue}
                            </Column>
                            <Column
                              className="reimbursement-success-result"
                              style={{
                                ...fonts.ML,
                                opacity: 0.5,
                              }}>
                              {'-'} {getCurrencyCode(undefined, 'createRefund')}
                            </Column>
                          </Row>
                        </Column>
                      </Row>
                    </Column>
                  </Row>
                </Column>
              </Column>
            </div>
          );
        })}
        <Column className="reimbursement-success-outer">
          <Column className="reimbursement-success-box-column">
            <Row className="reimbursement-success-row">
              <Column className="reimbursement-success-row-column column-responsive">
                <Row className="reimbursement-success-row-template success-responsive">
                  <Column className="reimbursement-success-row-left left-success reimbursement-success-total-amount-left-container">
                    <Row
                      className="reimbursement-success-row-left-align reimbursement-success-total-value"
                      style={{
                        ...fonts.L,
                        fontWeight: 'bold',
                        color: colors.black,
                      }}>
                      {refundLabels.refundDetail_totalValue}
                    </Row>
                  </Column>
                  <Column className="reimbursement-success-row-right right-success">
                    <Row className="reimbursement-success-row-left-align">
                      <Column
                        className="reimbursement-success-right-label reimbursement-success-total-value-responsive"
                        style={{
                          ...fonts.ML,
                          fontWeight: 'bold',
                          color: colors.black,
                        }}>
                        {refundLabels.refundDetail_totalValue}
                      </Column>
                      <Column
                        className="reimbursement-success-result reimbursement-success-result-total-value"
                        style={{...fonts.L, color: colors.black}}>
                        {calculateTotalValue(totalValue)}{' '}
                        {getCurrencyCode(undefined, 'createRefund')}
                      </Column>
                    </Row>
                    <Row className="reimbursement-success-row-left-align reimbursement-success-row-detail-label">
                      <Column
                        className="reimbursement-success-right-label"
                        style={{...fonts.ML}}>
                        {refundLabels.refundDetail_client}
                      </Column>
                      <Column
                        className="reimbursement-success-result"
                        style={{
                          ...fonts.ML,
                          opacity: 0.5,
                        }}>
                        {'-'} {getCurrencyCode(undefined, 'createRefund')}
                      </Column>
                    </Row>
                    <Row className="reimbursement-success-row-left-align">
                      <Column
                        className="reimbursement-success-right-label"
                        style={{...fonts.ML}}>
                        {refundLabels.refundDetail_refundValue}
                      </Column>
                      <Column
                        className="reimbursement-success-result"
                        style={{
                          ...fonts.ML,
                          opacity: 0.5,
                        }}>
                        {'-'} {getCurrencyCode(undefined, 'createRefund')}
                      </Column>
                    </Row>
                  </Column>
                </Row>
              </Column>
            </Row>
          </Column>
        </Column>
      </Column>
      <Link
        to="/historico-reembolsos"
        className="reimbursement-header-content-exit-label success-exit"
        style={{
          ...fonts.SM,
          color: globalStyles?.primaryColor || colors.fluorescentBlue,
          fontWeight: 'bold',
        }}>
        {labels?.createRefund_leaveRequest}
        <Icon
          className="reimbursement-header-content-close-icon svg-close-button inline-svg-close-button"
          name={Icons.CLOSE}
          width={'12'}
          height={'12'}
          changeViewbox={true}
          strokeWidth={'0.5'}
        />
      </Link>
    </>
  );
}

const mapStateToProps = ({user, wizard, strings, globalStyles}: any) => ({
  user: user.value,
  wizard: wizard.value,
  labels: strings.value.pt.createRefund,
  refundLabels: strings.value.pt.refund,
  globalStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ReimbursementSuccess),
);
